import React from "react"

import ThemeConsumer from "../ThemeConsumer"
import ImageOk from "../../../assets/svg/icon-ok.svg"
import Button from "../Button/Button"
import EmptyState from "../EmptyState/index"

const InactiveProductsEmptyState = () => {
  return (
    <EmptyState
      icon={ImageOk}
      title="Você não possui nenhum produto ativo!"
      description="Você não possui produtos ativos."
    >
      <Button toLinkBtn fontWeight="fw-5" isLink url="/AreaClienteCorporativo">
        Ir para página inicial
      </Button>
    </EmptyState>
  )
}

export default ThemeConsumer("UIEmptyState")(InactiveProductsEmptyState)



// WEBPACK FOOTER //
// ./src/shared/components/InactiveProductsEmptyState/index.js